import { useCallback } from 'react';
import { debounce } from 'lodash';

const useDebounce = (callback, delay) =>
  useCallback(debounce(callback, delay), [delay]);

export default useDebounce;
